import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../useStore';
import { getallReguser } from '../../features/Registration/registrationSlice';


const RecruitmentSettings = ({ inputs, setInputs }) => {

	const dispatch = useAppDispatch();
	const { dataAll } = useAppSelector(
		(state: { registration: any }) => state.registration
	);

	useEffect(() => {
		dispatch(getallReguser());
	}, [dispatch]);


	const [date, setDate] = useState({
		start: '',
		end: '',
	})



	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				// @ts-ignore 
				openingDate: moment(new Date(date.start)).toISOString(),
				// @ts-ignore 
				expiryDate: moment(new Date(date.end)).toISOString()
			});
		});

	}, [date.end, date.start, setInputs]);


	const handleData = (input: any, value: any) => {
		setDate((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};
	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	return (
		<div className='Job_Description_Header'>
			<div>
				<div style={{ width: "100%", marginTop: "20px" }}>
					<h6 className='employment-title-h6'>Qualifications</h6>

					<div className='AddJob_main_Description'>
						<div className='AddJob_main_Description_Top addJob_main_Description-text' style={{ height: "50%", }} >
							<p>Do you want to make this job offer private?</p>
							<div>

								<input
									type="checkbox"
									id="toggle-makejobprivate"
									className="toggle__checkbox"
									checked={inputs.makeJobPrivate}
									onChange={(e) => handleOnChange("makeJobPrivate", e.target.checked)}
								/>
								<label htmlFor="toggle-makejobprivate" className="toggle__wrap  toggle__circle">
									<label htmlFor="toggle-makejobprivate" className="toggle__label  toggle__circle  toggle__text"></label>
								</label>
							</div></div>
						<div style={{ height: "60%" }}>
							{/* @ts-ignore */}
							<div id="AddJob_main_Description_Inpout" rows="10" cols="150">
								This will job visible to only the employees of Outcess Solutions.</div>
						</div>
					</div>
				</div>




				<div className='AddJob_main_container_input'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Hiring Manager</h6>
						<select className="round"
							value={inputs.hiringManager}
							onChange={(e) => handleOnChange("hiringManager", e.target.value)}>
							<option>Select Hiring Manager</option>
							{dataAll?.data?.map((item: any, i: any) => (
								<option key={i} value={item?.id}>
									{item?.firstName + " " + item?.LastName}
								</option>
							))}
						</select>

					</div>
					<div style={{ margin: '20px' }} />
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Recruiter Tagged</h6>

						<select className="round"
							value={inputs.recruiterTagged}
							onChange={(e) => handleOnChange("recruiterTagged", e.target.value)}>
							<option>Recruiter Tagged</option>
							{dataAll?.data?.map((item: any, i: any) => (
								<option key={i} value={item?.id}>
									{item?.firstName + " " + item?.LastName}
								</option>
							))}
						</select>
					</div>

				</div>
				<div className='AddJob_main_container_input'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Number of Openings</h6>

						<input
							className="AddJobinput"
							type="number"
							value={inputs.numberOfOpenings}
							onChange={(e) => handleOnChange("numberOfOpenings", e.target.value)}
							placeholder='Number of Openings '
						/>
					</div>
					<div style={{ margin: '20px' }} />
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Opening Date </h6>

						<input
							className="AddJobinput"
							type="date"
							value={date.start}
							onChange={(e) => handleData("start", e.target.value)}
						/>
					</div>
					<div style={{ margin: '20px' }} />
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Expiry Date </h6>

						<input
							className="AddJobinput"
							type="date"
							value={date.end}
							onChange={(e) => handleData("end", e.target.value)}
						/>
					</div>
				</div>

				<div style={{ width: "100%", marginTop: "20px" }}>
					<h6 className='employment-title-h6'>summary</h6>

					<div className='AddJob_main_Description'>
						<div className='AddJob_main_Description_Top' style={{ height: "40%", }} >Enter Job summary </div>
						<div style={{ height: "60%" }}>
							{/* @ts-ignore */}
							<textarea id="AddJob_main_Description_Inpout" rows="10" cols="150"
								value={inputs.summary}
								onChange={(e) => handleOnChange("summary", e.target.value)} />
						</div>
					</div>
				</div>

			</div>
		</div >
	)
}

export default RecruitmentSettings